// ─── Traductions FR / EN ──────────────────────────────────────────────────────

export type Lang = 'fr' | 'en';

export const translations = {
  fr: {
    // ── Dashboard — Hero ──────────────────────────────────────────────────────
    hero_badge:        '40+ vérifications · DAST · Secret Scanner · Conformité NIS2',
    hero_title_1:      'Audit de sécurité web',
    hero_title_2:      'complet en 60\u00a0secondes',
    hero_subtitle:     "SSL, DNS, ports, DAST actif, credentials exposés, conformité NIS2\u00a0& RGPD \u2014 un rapport structuré avec score\u00a0/100 et plan d'action priorisé. Sans installation. Sans accès serveur.",
    hero_try:          'Essayez\u00a0:',
    placeholder:       'votreentreprise.fr',

    // ── Badges vérifications ──────────────────────────────────────────────────
    badge_headers:     'En-têtes HTTP',
    badge_spf:         'SPF\u00a0/\u00a0DKIM\u00a0/\u00a0DMARC',
    badge_ssl:         'SSL\u00a0/\u00a0TLS',
    badge_ports:       'Ports réseau',
    badge_tech:        'Technologies',
    badge_dnsbl:       'Listes noires',

    // ── Boutons / actions ─────────────────────────────────────────────────────
    btn_scan:          'Analyser',
    btn_new_scan:      'Nouveau scan',
    btn_retry:         'Réessayer',
    btn_report:        'Recevoir le rapport expert complet',
    btn_close:         'Fermer',
    btn_redownload:    'Re-télécharger le rapport PDF',

    // ── Résultats scan ────────────────────────────────────────────────────────
    scan_error:        'Scan impossible',
    scan_duration:     'Scanné en {ms}ms\u00a0·\u00a0{date}',
    vulns_found:       'Vulnérabilités détectées',
    vulns_none:        'Excellent\u00a0! Aucune vulnérabilité détectée.',
    vulns_none_sub:    "Votre infrastructure publique présente une bonne hygiène de sécurité. Un audit complet peut identifier des vecteurs d'attaque non visibles passivement.",
    findings_info:     "observation(s) informative(s)",
    ports_map:         'Carte des ports scannés',
    ports_open:        'ouvert(s)\u00a0/\u00a0{closed} fermé(s)',
    stat_vulns:        'Vulnérabilités',
    stat_ports:        'Ports critiques',
    stat_dns:          'Pénalités DNS',
    stat_ssl:          'Pénalités SSL',

    // ── Catégories findings ───────────────────────────────────────────────────
    cat_dns:           '📧 DNS & Mail',
    cat_ssl:           '🔒 SSL\u00a0/\u00a0HTTPS',
    cat_ports:         '🌐 Ports réseau',
    cat_headers:       '🛡️ En-têtes HTTP',
    cat_email_sec:     '📨 Sécurité Email',
    cat_tech:          '🔍 Technologie',
    cat_reputation:    '🌐 Réputation',
    cat_vuln_versions: '🐛 Versions Vulnérables',
    cat_subdomains:    '🗺️ Sous-domaines & Certificats',

    // ── Groupes de findings (Dashboard) ──────────────────────────────────────
    group_dns:         'DNS & Mail',
    group_ssl:         'SSL\u00a0/\u00a0HTTPS',
    group_ports:       'Exposition Réseau',
    group_headers:     'En-têtes de Sécurité HTTP',
    group_email:       'Authentification Email',
    group_tech:        'Exposition Technologique',
    group_reputation:  'Réputation du Domaine',

    // ── Sévérités ─────────────────────────────────────────────────────────────
    sev_critical:      'CRITIQUE',
    sev_high:          'ÉLEVÉ',
    sev_medium:        'MODÉRÉ',
    sev_low:           'FAIBLE',
    sev_info:          'INFO',

    // ── FindingCard ───────────────────────────────────────────────────────────
    finding_meaning:   'Ce que ça signifie pour vous',
    finding_technical: 'Détail technique',
    finding_reco:      'Recommandation',

    // ── ScoreGauge ────────────────────────────────────────────────────────────
    risk_critical:     'Critique',
    risk_high:         'Élevé',
    risk_medium:       'Modéré',
    risk_low:          'Faible',
    risk_label:        'Niveau de risque\u00a0:',
    gauge_scale_bad:   '0–39 Critique',
    gauge_scale_mid:   '40–69 Risqué',
    gauge_scale_good:  '70–100 Bon',

    // ── ScanConsole ───────────────────────────────────────────────────────────
    console_title:     'cyberhealth-scanner — audit {domain}',
    console_scanning:  'Analyse en cours...',
    console_passive:   'Scan passif en cours — aucune modification effectuée sur votre infrastructure',

    // ── CTABanner ─────────────────────────────────────────────────────────────
    cta_title_critical: '🚨 Infrastructure en danger immédiat',
    cta_title_high:     '⚠️ Risques de sécurité détectés',
    cta_body_critical:  'Avec un score de {score}/100, {domain} est exposé à des attaques ransomware imminentes.',
    cta_body_high:      'Votre score de {score}/100 indique des vulnérabilités exploitables par des attaquants opportunistes.',
    cta_audit:          'Télécharger le rapport complet',
    cta_call:           'Appeler maintenant',

    // ── EmailCaptureModal ─────────────────────────────────────────────────────
    modal_title:        'Rapport Expert Complet',
    modal_pdf_sub:      'Généré instantanément — PDF de 8 pages',
    modal_email_sub:    'Envoyé par email dans les 5 minutes',
    modal_critical_body: 'Score {score}/100 détecté. Votre rapport inclut un plan d\'action d\'urgence (J+7) et l\'estimation des pertes financières en cas d\'attaque.',
    modal_critical_cta: '+ 30 min de consultation offerte.',
    modal_normal_body_1:     'Rapport de',
    modal_normal_body_pages: '8 pages',
    modal_normal_body_2:     'incluant\u00a0: plan de remédiation, analyse RGPD/NIS2, et',
    modal_normal_body:  'Rapport de <strong>8 pages</strong> incluant\u00a0: plan de remédiation, analyse RGPD/NIS2, et',
    modal_consult:      '30 min de consultation offerte',
    modal_score:        'Score analysé\u00a0:',
    modal_firstname:    'Prénom *',
    modal_lastname:     'Nom *',
    modal_company:      'Entreprise (optionnel)',
    modal_email:        'votre@email.pro *',
    modal_btn_loading:  'Enregistrement…',
    modal_btn_pdf:      'Génération du PDF…',
    modal_btn_download: 'Télécharger mon rapport PDF',
    modal_btn_email:    'Recevoir mon rapport par email',
    modal_gen_title:    'Génération du rapport PDF en cours…',
    modal_gen_sub:      'Compilation des 8 pages, mise en page, export… (~15s)',
    modal_connect:      'Connexion au serveur…',
    modal_legal:        "En soumettant ce formulaire, vous acceptez d'être contacté par notre équipe.\u00a0Désabonnement en 1 clic\u00a0· Données protégées conformément au RGPD.",
    modal_success_pdf:  'Rapport téléchargé\u00a0! 📄',
    modal_success_req:  'Demande enregistrée\u00a0! 🚀',
    modal_success_pdf_body: 'Votre rapport PDF a été généré et téléchargé automatiquement. Vérifiez votre dossier Téléchargements.',
    modal_success_email_body: 'Votre rapport expert sera envoyé à {email} dans quelques minutes.',
    modal_next_steps:   'Prochaines étapes',
    modal_step1:        'Vérifiez votre boîte mail (et les spams) pour la confirmation.',
    modal_step2:        'Un consultant vous contactera sous 24h pour analyser vos résultats.',
    modal_step3:        '30 min de consultation offertes incluses dans le rapport.',
    modal_redownload:   'Re-télécharger le rapport PDF',

    // ── ContactPage ───────────────────────────────────────────────────────────
    contact_back:            'Retour',
    contact_nav_title:       'Support & Contact',
    contact_heading:         'Une question\u00a0? Un problème\u00a0?',
    contact_subheading:      'Notre équipe vous répond sous',
    contact_subheading_time: '24 à 48 heures ouvrées',
    contact_label_name:      'Nom complet',
    contact_label_email:     'Email',
    contact_label_subject:   'Sujet',
    contact_label_message:   'Message',
    contact_placeholder_name:    'Jean Dupont',
    contact_placeholder_email:   'jean@entreprise.com',
    contact_placeholder_message: 'Décrivez votre demande en détail...',
    contact_submit:          'Envoyer le message',
    contact_sending:         'Envoi en cours...',
    contact_success_title:   'Message envoyé\u00a0!',
    contact_success_body:    'Nous avons bien reçu votre demande et vous avez reçu un accusé de réception par email. Notre équipe vous répondra dans les meilleurs délais.',
    contact_success_back:    '← Retour à l\'accueil',
    contact_info_email_title:    'Réponse par email',
    contact_info_email_delay:    'Sous 24–48h ouvrées',
    contact_info_ack_title:      'Accusé de réception',
    contact_info_ack_body:       'Envoyé automatiquement',
    contact_err_name:        'Nom requis (min. 2 caractères)',
    contact_err_email:       'Email invalide',
    contact_err_message:     'Message trop court (min. 10 caractères)',
    contact_err_generic:     'Une erreur est survenue. Réessayez.',
    contact_subject_0:       'Question sur mon compte',
    contact_subject_1:       'Problème technique',
    contact_subject_2:       'Question sur les tarifs / offres',
    contact_subject_3:       'Demande de démo',
    contact_subject_4:       'Signaler un bug',
    contact_subject_5:       'Autre',
  },

  en: {
    // ── Dashboard — Hero ──────────────────────────────────────────────────────
    hero_badge:        '40+ checks · DAST · Secret Scanner · NIS2 compliance',
    hero_title_1:      'Complete web security',
    hero_title_2:      'audit in 60\u00a0seconds',
    hero_subtitle:     'SSL, DNS, ports, active DAST, exposed credentials, NIS2\u00a0& GDPR compliance \u2014 a structured report with score\u00a0/100 and prioritised action plan. No installation. No server access.',
    hero_try:          'Try:',
    placeholder:       'yourbusiness.com',

    // ── Badges vérifications ──────────────────────────────────────────────────
    badge_headers:     'HTTP Headers',
    badge_spf:         'SPF\u00a0/\u00a0DKIM\u00a0/\u00a0DMARC',
    badge_ssl:         'SSL\u00a0/\u00a0TLS',
    badge_ports:       'Network Ports',
    badge_tech:        'Technologies',
    badge_dnsbl:       'Blacklists',

    // ── Boutons / actions ─────────────────────────────────────────────────────
    btn_scan:          'Analyze',
    btn_new_scan:      'New scan',
    btn_retry:         'Retry',
    btn_report:        'Get the full expert report',
    btn_close:         'Close',
    btn_redownload:    'Re-download PDF report',

    // ── Résultats scan ────────────────────────────────────────────────────────
    scan_error:        'Scan failed',
    scan_duration:     'Scanned in {ms}ms\u00a0·\u00a0{date}',
    vulns_found:       'Vulnerabilities detected',
    vulns_none:        'Excellent! No vulnerabilities detected.',
    vulns_none_sub:    'Your public infrastructure shows good security hygiene. A full audit may uncover attack vectors not visible passively.',
    findings_info:     'informational finding(s)',
    ports_map:         'Scanned ports map',
    ports_open:        'open\u00a0/\u00a0{closed} closed',
    stat_vulns:        'Vulnerabilities',
    stat_ports:        'Critical ports',
    stat_dns:          'DNS penalties',
    stat_ssl:          'SSL penalties',

    // ── Catégories findings ───────────────────────────────────────────────────
    cat_dns:           '📧 DNS & Mail',
    cat_ssl:           '🔒 SSL\u00a0/\u00a0HTTPS',
    cat_ports:         '🌐 Network Ports',
    cat_headers:       '🛡️ HTTP Headers',
    cat_email_sec:     '📨 Email Security',
    cat_tech:          '🔍 Technology',
    cat_reputation:    '🌐 Reputation',
    cat_vuln_versions: '🐛 Vulnerable Versions',
    cat_subdomains:    '🗺️ Subdomains & Certificates',

    // ── Groupes de findings (Dashboard) ──────────────────────────────────────
    group_dns:         'DNS & Mail',
    group_ssl:         'SSL\u00a0/\u00a0HTTPS',
    group_ports:       'Network Exposure',
    group_headers:     'HTTP Security Headers',
    group_email:       'Email Authentication',
    group_tech:        'Technology Exposure',
    group_reputation:  'Domain Reputation',

    // ── Sévérités ─────────────────────────────────────────────────────────────
    sev_critical:      'CRITICAL',
    sev_high:          'HIGH',
    sev_medium:        'MEDIUM',
    sev_low:           'LOW',
    sev_info:          'INFO',

    // ── FindingCard ───────────────────────────────────────────────────────────
    finding_meaning:   'What this means for you',
    finding_technical: 'Technical detail',
    finding_reco:      'Recommendation',

    // ── ScoreGauge ────────────────────────────────────────────────────────────
    risk_critical:     'Critical',
    risk_high:         'High',
    risk_medium:       'Moderate',
    risk_low:          'Low',
    risk_label:        'Risk level:',
    gauge_scale_bad:   '0–39 Critical',
    gauge_scale_mid:   '40–69 Risky',
    gauge_scale_good:  '70–100 Good',

    // ── ScanConsole ───────────────────────────────────────────────────────────
    console_title:     'cyberhealth-scanner — audit {domain}',
    console_scanning:  'Scanning in progress...',
    console_passive:   'Passive scan in progress — no changes made to your infrastructure',

    // ── CTABanner ─────────────────────────────────────────────────────────────
    cta_title_critical: '🚨 Infrastructure at immediate risk',
    cta_title_high:     '⚠️ Security risks detected',
    cta_body_critical:  'With a score of {score}/100, {domain} is exposed to imminent ransomware attacks.',
    cta_body_high:      'Your score of {score}/100 indicates vulnerabilities exploitable by opportunistic attackers.',
    cta_audit:          'Download full report',
    cta_call:           'Call now',

    // ── EmailCaptureModal ─────────────────────────────────────────────────────
    modal_title:        'Full Expert Report',
    modal_pdf_sub:      'Generated instantly — 8-page PDF',
    modal_email_sub:    'Sent by email within 5 minutes',
    modal_critical_body: 'Score {score}/100 detected. Your report includes an emergency action plan (D+7).',
    modal_critical_cta: '+ 30 min free consultation included.',
    modal_normal_body_1:     'Report of',
    modal_normal_body_pages: '8 pages',
    modal_normal_body_2:     'including: remediation plan, GDPR/NIS2 analysis, and',
    modal_normal_body:  '<strong>8-page</strong> report including: remediation plan, GDPR/NIS2 analysis, and',
    modal_consult:      '30 min free consultation',
    modal_score:        'Analyzed score:',
    modal_firstname:    'First name *',
    modal_lastname:     'Last name *',
    modal_company:      'Company (optional)',
    modal_email:        'your@business.email *',
    modal_btn_loading:  'Saving…',
    modal_btn_pdf:      'Generating PDF…',
    modal_btn_download: 'Download my PDF report',
    modal_btn_email:    'Receive my report by email',
    modal_gen_title:    'Generating PDF report…',
    modal_gen_sub:      'Compiling 8 pages, layout, export… (~15s)',
    modal_connect:      'Connecting to server…',
    modal_legal:        'By submitting this form, you agree to be contacted by our team.\u00a0One-click unsubscribe\u00a0· Data protected under GDPR.',
    modal_success_pdf:  'Report downloaded! 📄',
    modal_success_req:  'Request registered! 🚀',
    modal_success_pdf_body: 'Your PDF report has been generated and downloaded automatically. Check your Downloads folder.',
    modal_success_email_body: 'Your expert report will be sent to {email} in a few minutes.',
    modal_next_steps:   'Next steps',
    modal_step1:        'Check your inbox (and spam folder) for the confirmation.',
    modal_step2:        'A consultant will contact you within 24h to review your results.',
    modal_step3:        '30 min free consultation included in the report.',
    modal_redownload:   'Re-download PDF report',

    // ── ContactPage ───────────────────────────────────────────────────────────
    contact_back:            'Back',
    contact_nav_title:       'Support & Contact',
    contact_heading:         'A question? A problem?',
    contact_subheading:      'Our team responds within',
    contact_subheading_time: '24 to 48 business hours',
    contact_label_name:      'Full name',
    contact_label_email:     'Email',
    contact_label_subject:   'Subject',
    contact_label_message:   'Message',
    contact_placeholder_name:    'John Smith',
    contact_placeholder_email:   'john@company.com',
    contact_placeholder_message: 'Describe your request in detail...',
    contact_submit:          'Send message',
    contact_sending:         'Sending...',
    contact_success_title:   'Message sent!',
    contact_success_body:    'We have received your request and you have been sent an acknowledgement by email. Our team will get back to you as soon as possible.',
    contact_success_back:    '← Back to home',
    contact_info_email_title:    'Email reply',
    contact_info_email_delay:    'Within 24–48 business hours',
    contact_info_ack_title:      'Acknowledgement',
    contact_info_ack_body:       'Sent automatically',
    contact_err_name:        'Name required (min. 2 characters)',
    contact_err_email:       'Invalid email',
    contact_err_message:     'Message too short (min. 10 characters)',
    contact_err_generic:     'An error occurred. Please try again.',
    contact_subject_0:       'Account question',
    contact_subject_1:       'Technical issue',
    contact_subject_2:       'Pricing / plans question',
    contact_subject_3:       'Demo request',
    contact_subject_4:       'Report a bug',
    contact_subject_5:       'Other',
  },
} as const;

export type TranslationKey = keyof typeof translations.fr;
